import { Component, Injector, OnInit } from '@angular/core';
import { ChassisFormHandler, FormFactory, PluginDataInterface, trans } from '@kaiser-software/chassis-core';
import { CategoryModel } from '../../../models/category.model';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { CategoryService } from '../../../services/category.service';

@Component({
    selector: 'app-observation-categories-create',
    templateUrl: 'create.component.html',
    styleUrls: ['create.component.scss']
})
export class CategoriesCreateComponent implements OnInit {

    public form: ChassisFormHandler;

    public model: CategoryModel = new CategoryModel();

    protected singular = 'Category';

    protected plural = 'Categories';

    protected title = 'Create category';

    protected routePrefix = 'observation-categories';

    protected pluginPrefix = 'eyewatch-observation-categories-create';

    protected subject: ReplaySubject<any> = new ReplaySubject();

    protected pluginData: PluginDataInterface;

    /**
     * @param injector
     * @param categoryService
     * @param formFactory
     */
    constructor(
        protected injector: Injector,
        protected categoryService: CategoryService,
        protected formFactory: FormFactory,
    ) {
        //
    }

    public ngOnInit(): void {
        this.createForm();
        this.setupPlugins();
    }

    public ngAfterViewInit() {

    }

    protected createForm(): void {
        this.model = this.categoryService.make();
        this.subject.next(this.model);

        this.form = this.formFactory.create(
            this.fields(),
            this.model
        );

        this.form.success((result) => {
            this.subject.next(result);
        });
    }

    protected fields(): any {
        return {
            groups: [{
                id: 1,
                name: 'General',
                order: 1,
                sections: [{
                    id: 'section',
                    order: 1,
                    rows: [{
                        id: 'title',
                        order: -1,
                        elements: [{
                            id: 'title',
                            type: 'text',
                            name: 'title',
                            label: trans('Title'),
                            validation: {
                                required: true
                            },
                            attributes: {
                                placeholder: trans('Title'),
                                title: trans('Title')
                            }
                        }, {
                            id: 'code',
                            type: 'text',
                            name: 'code',
                            label: trans('Code'),
                            validation: {
                                required: true
                            },
                            attributes: {
                                placeholder: trans('Code'),
                                title: trans('Code')
                            }
                        }, {
                            id: 'description',
                            type: 'textarea',
                            name: 'description',
                            label: trans('Description'),
                            validation: {
                                required: true
                            },
                            attributes: {
                                placeholder: trans('Description'),
                                title: trans('Description')
                            }
                        }, {
                            id: 'category',
                            type: 'select-2',
                            name: 'category',
                            label: trans('Main category'),
                            config: {
                                url: this.categoryService.getEndpointUrl(),
                                useScope: false,
                                relation: true,
                                searchKeyColumn: 'id',
                                searchQueryColumn: 'title',
                                searchDisplayColumn: 'title',
                                params: {
                                    filter: 'id;code;title'
                                }
                            },
                            attributes: {
                                placeholder: trans('Main category'),
                                title: trans('Main category')
                            }
                        }],
                    }],
                }],
            }],
        };
    }

    protected setupPlugins(): void {
        this.pluginData = {
            inputs: {
                form: this.form,
                model: this.subject,
                modelSubject: this.subject,
            }
        };
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/pages/categories/create/create.component.ts